import localAdminApi from '../utils/localAdminApi';

export const faqService = {
  // Get all FAQs with optional filtering
  getAllFAQs: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.category) params.append('category', filters.category);
    if (filters.asset_id) params.append('asset_id', filters.asset_id);
    if (filters.package_id) params.append('package_id', filters.package_id);
    
    const queryString = params.toString();
    const url = queryString ? `/api/admin/faqs?${queryString}` : '/api/admin/faqs';
    
    const response = await localAdminApi.get(url);
    return response.data;
  },

  // Get single FAQ by ID
  getFAQById: async (faqId) => {
    const response = await localAdminApi.get(`/api/admin/faqs/${faqId}`);
    return response.data;
  },

  // Create new FAQ
  createFAQ: async (faqData) => {
    const response = await localAdminApi.post('/api/admin/faqs', faqData);
    return response.data;
  },

  // Update existing FAQ
  updateFAQ: async (faqId, updateData) => {
    const response = await localAdminApi.put(`/api/admin/faqs/${faqId}`, updateData);
    return response.data;
  },

  // Delete FAQ
  deleteFAQ: async (faqId) => {
    const response = await localAdminApi.delete(`/api/admin/faqs/${faqId}`);
    return response.data;
  },

  // Reorder FAQ
  reorderFAQ: async (faqId, newOrder) => {
    const response = await localAdminApi.put(`/api/admin/faqs/${faqId}/reorder`, {
      new_order: newOrder
    });
    return response.data;
  },

  // Get FAQs by category (convenience methods)
  getHowItWorksFAQs: async () => {
    return faqService.getAllFAQs({ category: 'how-it-works' });
  },

  getIndividualAssetsFAQs: async (assetId = null) => {
    const filters = { category: 'individual-assets' };
    if (assetId) filters.asset_id = assetId;
    return faqService.getAllFAQs(filters);
  },

  getCuratedAssetsFAQs: async (packageId = null) => {
    const filters = { category: 'curated-assets' };
    if (packageId) filters.package_id = packageId;
    return faqService.getAllFAQs(filters);
  },

  getHelpCentreFAQs: async () => {
    return faqService.getAllFAQs({ category: 'help-centre' });
  }
};